<template>
  <div v-if="me" class="container-fluid">
    <div class="row">
      <div class="col-12 mb-4">
        <div class="card">
          <div class="card-header pb-1">
            <h5>Przeglądy</h5>
          </div>
          <div class="card-body p-0">
            <div class="table-responsive pt-1">
              <div class="dataTable-wrapper dataTable-loading no-footer searchable fixed-height fixed-columns">
                <div class="dataTable-container">
                  <table class="table table-flush dataTable-table">
                    <thead class="thead-light">
                      <tr>
                        <th class="text-uppercase text-secondary text-xxs font-weight-bolder" style="width: 10%">
                          Nr.
                        </th>

                        <th class="ps-0 text-uppercase text-secondary text-xxs font-weight-bolder" style="width: 20%">
                          Data realizacji
                        </th>

                        <th class="ps-0 text-uppercase text-secondary text-xxs font-weight-bolder" style="width: 10%">
                          Status
                        </th>

                        <th class="ps-0 text-uppercase text-secondary text-xxs font-weight-bolder" style="width: 10%">
                          Osiedle
                        </th>

                        <th class="ps-0 text-uppercase text-secondary text-xxs font-weight-bolder" style="width: 25%">
                          Kategorie / Czynności
                        </th>

                        <th class="ps-0 text-uppercase text-secondary text-xxs font-weight-bolder" style="width: 25%">
                          Firma wykonawcy
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in inspections"
                        :key="item"
                        class="cursor-pointer"
                        @click="goToInspection(item.id)"
                      >
                        <!-- Tabela: Nr. -->
                        <td class="text-wrap">
                          <p class="m-0 text-xs font-weight-bold">{{ item.numerPrzegladu }}</p>
                        </td>

                        <!-- Tabela: Data realizacji -->
                        <td class="ps-0 text-wrap">
                          <p class="m-0 text-xs">{{ item.dataPoczatkowa + " - " + item.dataKoncowa }}</p>
                        </td>

                        <!-- Tabela: Status -->
                        <td class="ps-0">
                          <material-badge v-if="item.status == 1" color="primary" size="sm" class="m-0">Nowy</material-badge>
                          <material-badge v-if="item.status == 2" color="warning" size="sm" class="m-0">W realizacji</material-badge>
                          <material-badge v-if="item.status == 3" color="danger" size="sm" class="m-0">Problem</material-badge>
                          <material-badge v-if="item.status == 4" color="dark" size="sm" class="m-0">Anulowano</material-badge>
                          <material-badge v-if="item.status == 5" color="success" size="sm" class="m-0">Zakończony</material-badge>
                        </td>

                        <!-- Tabela: Osiedle -->
                        <td class="ps-0 text-wrap">
                          <p class="m-0 text-xs font-weight-bold">{{ item.osiedla != "" ? item.osiedla : "-" }}</p>
                        </td>

                        <!-- Tabela: Kategorie / Czynności -->
                        <td class="ps-0 text-wrap">
                          <p class="m-0 text-xs font-weight-bold">{{ item.kategorie != "" ? item.kategorie : "-" }}</p>
                          <p class="m-0 text-xs">{{ item.czynnosci != "" ? item.czynnosci : "-" }}</p>
                        </td>

                        <!-- Tabela: Firma wykonawcy -->
                        <td class="ps-0 text-wrap">
                          <p class="m-0 text-xs font-weight-bold">{{ item.firmaWykonawcy }}</p>
                        </td>
                      </tr>

                      <!-- Brak przeglądów -->
                      <tr :class="inspections.length > 0 ? 'd-none' : ''">
                        <td class="dataTables-empty text-sm" colspan="6">Nie znaleziono przeglądów</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialBadge from "@/components/MaterialBadge.vue"
import UserDataService from "@/services/UserDataService"
import AsomDataService from "@/services/AsomDataService"
import { mapState } from "vuex"

export default {
  name: "Inspections",
  components: {
    MaterialBadge,
  },
  data() {
    return {
      me: null, // Obiekt zalogowanego użytkownika
      inspections: [], // Tablica zawierająca dane przeglądów z API
    }
  },
  computed: {
    ...mapState(["color"]),
  },
  created() {
    this.getMe()
  },
  methods: {
    // Funkcja pobierająca dane zalogowanego użytkownika
    getMe() {
      UserDataService.me()
      .then(res => {
        this.getUser(res.data.id)
      })
      .catch(error => {
        console.log(error)

        if(JSON.stringify(error.response.data.code) == 401) {
          this.$logout()
        }
      })
    },

    // Funkcja pobierająca dane zalogowanego użytkownika
    getUser(id) {
      UserDataService.get(id)
      .then(res => {
        if (res.data.deleted || res.data.status === "Dezaktywowany") {
          this.$logout()
        }
        else if (!res.data.roles.includes("ROLE_ASOM_INSPECTIONS")) {
          this.$redirect("Kokpit")
        }
        else {
          this.me = res.data
          this.getInspections()
        }
      })
      .catch(error => {
        console.log(error)

        if(JSON.stringify(error.response.data.code) == 401) {
          this.$logout()
        }
      })
    },

    // Funkcja pobierająca przeglądy z API
    getInspections() {
      AsomDataService.getInspections("")
      .then(res => {
        this.inspections = res.data
      })
      .catch(error => {
        console.log(error)

        if(JSON.stringify(error.response.data.code) == 401) {
          this.$logout()
        }
      })
    },

    // Funkcja przekierowująca do szczegółów przeglądu
    goToInspection(id) {
      window.open(`https://system.asom.pl/panel/nowy_layout/przeglad/${ id }`, "_blank")
    },
  },
}
</script>